import { BKJButton, Flex } from '@bookjane2/bookjane-design-library';
import { AutoMargin } from 'components/AutoMargin';
import { BKJSideModalFooter } from 'components/BKJSideModalFooter';
import { useEditCustomFieldFormContext } from 'components/CustomFieldEditModal/contexts/EditCustomField.form.context';
import { Description, Heading } from 'components/CustomFieldModal/CustomFieldModal.styled';
import { FC, Fragment } from 'react';
import { useTranslation } from 'hooks/useTranslation';

export const DeleteCustomFieldView: FC = () => {
  const { onDelete } = useEditCustomFieldFormContext();
  const { t } = useTranslation();

  return (
    <Fragment>
      <Flex flexDirection="column" gap="32px" padding="32px" flex="1">
        <Heading>{t('settings:DELETE_CUSTOM_FIELD')}?</Heading>
        <Description>{t('settings:DELETE_CUSTOM_FIELD_MESSAGE')}</Description>
      </Flex>
      <BKJSideModalFooter>
        <AutoMargin />
        <BKJButton variant="RedSolid" width="180px" onClick={onDelete}>
          {t('auth:DELETE')}
        </BKJButton>
      </BKJSideModalFooter>
    </Fragment>
  );
};
